function openTab(evt, tabName, tabWrapper) {
  const tabWrapperElement = document.getElementById(tabWrapper);

  // Hide all tab contents within the given tabWrapper
  const tabcontents = tabWrapperElement.querySelectorAll(
    '.main-product__tab-content'
  );
  tabcontents.forEach(content => {
    content.style.display = 'none';
  });

  // Remove 'active' class from all tab links within the given tabWrapper
  const tablinks = tabWrapperElement.querySelectorAll(
    '.main-product__tab'
  );
  tablinks.forEach(link => {
    link.classList.remove('active');
  });

  // Show the current tab and add the 'active' class to the button that opened the tab
  const currentTabContent = tabWrapperElement.querySelector(
    `#${tabName}`
  );
  if (currentTabContent) {
    currentTabContent.style.display = 'block';
    if (evt.currentTarget) {
      evt.currentTarget.classList.add('active');
    }
  }

  // Scroll to the current active tab
  const buttonsContainer = tabWrapperElement.querySelector('.main-product__tabs');
  const buttons = tabWrapperElement.querySelectorAll('.main-product__tab');
  const computedStyle = window.getComputedStyle(buttonsContainer);
  const gapValue = parseInt(computedStyle.getPropertyValue('gap'));

  let activeIndex = -1;
  let offsetValue = 0;
  let offsetValues = [];

  buttons.forEach((button, currentIndex) => {
    offsetValues.push(offsetValue);
    offsetValue += button.offsetWidth + gapValue;
    if (button.classList.contains('active')) {
      activeIndex = currentIndex;
      return;
    }
  });

  buttonsContainer.scrollLeft = offsetValues[activeIndex];
}

function toggleOpenTab(evt, tabName, tabWrapper) {
  const tabWrapperElement = document.getElementById(tabWrapper);

  //Get the tab that is currently active before they are all made inactive
  const previousActiveTab = tabWrapperElement.querySelector(
    '.main-product__tab-content[style*="display: block;"]'
  );

  //if previous active tab id = tabName toggle else do the existing functionality
  if(previousActiveTab && previousActiveTab.id == tabName) {
    const currentTabContent = tabWrapperElement.querySelector(
      `#${tabName}`
    );

    if (currentTabContent) {
      currentTabContent.style.display = currentTabContent.style.display === 'block' ? 'none': 'block';
      if (evt.currentTarget) {
        evt.currentTarget.classList.toggle('active');
      }
    }
  } else {
    openTab(evt, tabName, tabWrapper);
  }
}

function tabsScroll(tabWrapper, isNext) {
  const tabWrapperElement = document.getElementById(tabWrapper);
  const buttons = tabWrapperElement.querySelectorAll('.main-product__tab');

  let activeIndex = -1;

  buttons.forEach((button, currentIndex) => {
    if (button.classList.contains('active')) {
      activeIndex = currentIndex;
    }
  });

  //If there is no active button
  if(activeIndex < 0) {
    isNext ? buttons[0].click() : buttons[buttons.length - 1].click();
  } else {
    isNext ? buttons[activeIndex += 1].click() : buttons[activeIndex += -1].click();
  }
}

function toggleScrollButtons() {
  const outerWidth = document.querySelector('.tabs__button-wrapper').offsetWidth;
  const innerDiv = document.querySelector('.main-product__tabs');
  const tabButtons = innerDiv.querySelectorAll('.main-product__tab');
  const buttons = document.querySelector('.tabs__button-container');

  let innerWidth = 0;

  tabButtons.forEach((button) => {
    innerWidth += button.offsetWidth + 15;
  });

  if(outerWidth < innerWidth) {
    buttons.style.display = 'block';
    innerDiv.style.marginRight = `${buttons.offsetWidth + 10}px`;
  } else {
    buttons.style.display = 'none';
    innerDiv.style.marginRight = '0px';
  }
}

document.addEventListener('DOMContentLoaded', function () {
  function simulateClick(element) {
    const event = new MouseEvent('click', {
      view: window,
      bubbles: true,
      cancelable: true
    });
    element.dispatchEvent(event);
  }

  // Get all the wrapper elements for each instance
  const tabWrappers = document.querySelectorAll(
    '.main-product__tabs-wrapper'
  );

  // Loop through each instance to find and click the default open tab
  tabWrappers.forEach(wrapper => {
    // get the wrapperID only if it exists
    const wrapperID = wrapper.getAttribute('id');
    if (!wrapperID) return;

    // get all the tabs marked as default open for every instance
    const defaultOpenTabs = wrapper.querySelectorAll(
      '.main-product__tab[data-default-open]'
    );

    // Loop through each default open tab and click it
    defaultOpenTabs.forEach(tabToClick => {
      simulateClick(tabToClick);
    });
  });

  toggleScrollButtons();
});

window.addEventListener('resize', function() {
  toggleScrollButtons();
});

